// extracted by mini-css-extract-plugin
export default {"initials":"_5Jy1gtGyaaozTUf66lQ5lw=="};